import httpRequest from "@/core/http-request"

//数据请求
export const orgApi = {
    getOrgTree(){
        return httpRequest.get('/org/tree')
    },
    saveOrg(data){
        return httpRequest.post('/org/save', data)
    },
   
    deleteOrg(ids){
        return httpRequest.post('/org/del', ids)
    },
    async loadOrgOptions(){
        let orgTreeData = [];
        const { data } = await this.getOrgTree();        
        if (data && data.errorCode === "00000") {
            orgTreeData = data.result;
        }
        return orgTreeData;
    }
}